import React from "react";
import moment from "moment";
import styles from "./adInfo.scss"

const getDurationString = (years, months, days) => {
  if (years === 0 && months === 0 && days === 0) return "Aktivan manje od 1 dana";
  if (years === 0 && months === 0 && days > 0 && days % 10 === 1) return `Aktivan ${days} dan${days === 11 ? "a" : ""}`;
  if (years === 0 && months === 0 && days > 0) return `Aktivan ${days} dana`;
  if (years === 0 && months === 1) return "Aktivan 1 mjesec";
  if (years === 0 && months > 1) return `Aktivan ${months} mjesec${[2, 3, 4].includes(months) ? "a" : "i"}`;
  if (years === 1) return "Aktivan 1 godinu";
  if (years > 1) return `Aktivan ${years} godin${[2, 3, 4].includes(years) ? "e" : "a"}`;
}

export const AdCreatedDiff = ({ adCreatedAt }: { adCreatedAt: string }) => {
  const today = moment().startOf('day');
  const target = moment(adCreatedAt).startOf('day');
  const diffYears = today.diff(target, 'years');
  const diffMonths = today.diff(target, 'months');
  const diffDays = today.diff(target, 'days');
  const durationString = getDurationString(diffYears, diffMonths, diffDays)

  return (
    <p className={styles.descr}>{durationString}</p>
  )
}



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/AdInfo/AdCreatedDiff.tsx